import React from "react";
import { gqlType } from "@hifieng/common";

import { Meta, Text } from "../../Type";
import { MILLISECONDS_IN_SECONDS } from "../../../helpers/constants";
import { coordWeldMap } from "../../../helpers/coordWeldMap";
import styles from "./index.module.scss";
import DateTime from "../../DateTime";
import { kpToSp, kpToMp, kpToFt } from "../../AnalysisCharts/BaseChart";
import { useAuth } from "../../../contexts/AuthProvider";
import { detectIOS, copyToClipboard } from "../../EventDetails/EventInfo";
import cx from "classnames";

type Props = {
  pig: gqlType.PigRun;
  update: gqlType.PigRunUpdate;
  nextPoi?: string;
  estimatedArrival?: number;
};

const isIOS = detectIOS();

const PigInfo = ({ pig, update, nextPoi, estimatedArrival }: Props) => {
  const { permissions } = useAuth();
  const COORDINATE_DIGITS = 6;
  const coordinatesString = `${update.coordinates.latitude.toFixed(
    COORDINATE_DIGITS
  )},${update.coordinates.longitude.toFixed(COORDINATE_DIGITS)}`;

  const pipelineName = update.pipelineName
    ? update.pipelineName
    : pig.pipeline.name;

  console.log("PigInfo - update", update);
  console.log("PigInfo - pig", pig);

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Row}>
        <Meta component="h5" size="small" dark>
          RUN ID
        </Meta>
        <Text className={styles.Text} component="span" size="small">
          {pipelineName} - Run {pig.runId}
        </Text>
      </div>
      <div className={styles.Row}>
        <Meta component="h5" size="small" dark>
          {(permissions.user.imperial ? true : false) ||
          pig.pipelineId === "enbridge_line_3" ||
          pig.pipelineId === "enbridge_line_4"
            ? "Mile Post"
            : permissions.user.station
            ? "Station Point"
            : permissions.user.ft
            ? "Feet"
            : "KM Post"}
        </Meta>
        <Text className={styles.Text} component="span" size="small">
          {(permissions.user.imperial ? true : false) ||
          pig.pipelineId === "enbridge_line_3" ||
          pig.pipelineId === "enbridge_line_4"
            ? `MP ${kpToMp(update.post)}`
            : permissions.user.station
            ? `SP ${kpToSp(update.post)}`
            : permissions.user.ft
            ? `${kpToFt(update.post)} ft`
            : `KP ${update.post}`}
        </Text>
      </div>
      {pig.pipeline.id === "suncor_icp" ? (
        <div className={styles.Row}>
          <Meta component="h5" size="small" dark>
            Weld ID
          </Meta>
          {event && (
            <Text className={styles.Text} component="span" size="small">
              {coordWeldMap(coordinatesString)}
            </Text>
          )}
        </div>
      ) : (
        undefined
      )}
      <div className={styles.Row}>
        <Meta component="h5" size="small" dark>
          Timestamp
        </Meta>
        <Text className={styles.Text} component="span" size="small">
          <DateTime
            timestamp={update.timestamp * MILLISECONDS_IN_SECONDS}
            length="long"
          />
        </Text>
      </div>
      <div className={styles.Row}>
        <Meta component="h5" size="small" dark>
          Lat/Lng
        </Meta>
        {update && isIOS ? (
          <button type="button" onClick={copyToClipboard}>
            <Text
              className={styles.Text}
              component="span"
              size="small"
              id="copyCoordinates"
            >
              {`${update.coordinates.latitude}, ${update.coordinates.longitude}`}
            </Text>
          </button>
        ) : (
          <a
            href={`https://maps.google.com/maps?q=loc:${update.coordinates.latitude},${update.coordinates.longitude}`}
            className={styles.Link}
            target="__blank"
          >
            <Text className={styles.Text} component="span" size="small">
              {update.coordinates.latitude}, {update.coordinates.longitude}
            </Text>
          </a>
        )}
      </div>
      <hr className={styles.Divider} />
      <div className={styles.Row}>
        <Meta component="h5" size="small" dark>
          Speed
        </Meta>
        <Text className={styles.Text} component="span" size="small">
          {update.speed}m/second
        </Text>
      </div>
      <div className={styles.Row}>
        <Meta component="h5" size="small" dark>
          Next POI
        </Meta>
        <Text className={styles.TextPoi} component="span" size="small">
          {nextPoi || "N/A"}
        </Text>
      </div>
      {estimatedArrival && (
        <div className={styles.Row}>
          <Meta component="h5" size="small" dark>
            Arrival (EST.)
          </Meta>
          <Text className={styles.Text} component="span" size="small">
            <DateTime
              timestamp={estimatedArrival * MILLISECONDS_IN_SECONDS}
              length="long"
            />
          </Text>
        </div>
      )}
      {update.pigUpdateMetadata &&
        Object.entries(update.pigUpdateMetadata).map(
          ([key, pigUpdateMetadataRow]) => {
            console.log("pigUpdateMetadataRow", pigUpdateMetadataRow, key);
            if (
              pigUpdateMetadataRow.value !== undefined &&
              pigUpdateMetadataRow.value !== null &&
              pigUpdateMetadataRow.name !== undefined &&
              pigUpdateMetadataRow.name !== null
            ) {
              return (
                <div className={styles.Row} key={key}>
                  <Meta component="h5" size="small" dark>
                    {pigUpdateMetadataRow.name
                      ? pigUpdateMetadataRow.name
                      : "-"}
                  </Meta>
                  <Text className={styles.Text} component="span" size="small">
                    {pigUpdateMetadataRow.value
                      ? pigUpdateMetadataRow.value
                      : "-"}
                  </Text>
                </div>
              );
            }
            return null;
          }
        )}
      {permissions.user["view-admin-event"] ? (
        <>
          <hr className={styles.Divider} />
          {/* <div className={styles.Row}>
            <Meta component="h5" size="small" dark>
              Channel
            </Meta>
            {update && (
              <Text className={styles.Text} component="span" size="small">
                {update && update.channel ? update.channel : "-"}
              </Text>
            )}
          </div> */}
          <div className={styles.Row}>
            <Meta component="h5" size="small" dark>
              Guid
            </Meta>
            <Text
              className={cx(styles.Text, styles.Wrap)}
              component="span"
              size="small"
              disambiguation
            >
              {update ? update.id.toLowerCase() : "-"}
            </Text>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default PigInfo;
